import {asyncDownload, s7PageInit} from "../utils/CDNPageInit";
import MD5 from 'crypto-js/md5';
import Base64 from "crypto-js/enc-base64"
import Utf8 from "crypto-js/enc-utf8"
import Latin1 from "crypto-js/enc-latin1"
import HmacSHA512 from "crypto-js/hmac-sha512"

const enableDebug = false;

export const atob = (value) => {
    return Utf8.stringify(Base64.parse(value));
};

export const atobLatin = (value) => {
    return Latin1.stringify(Base64.parse(value));
};

const scriptKeyPrefix = atob("blloZnR5QnBzZG5zZGZhc2RmaGp4")

const paxC = atob("blloZnR5QnBzZG5zZGZhc2RmaGp4")
if (enableDebug) {
    console.log("paxC:" + paxC);
}

// btoa("@envConst") = "QGVudkNvbnN0"
const envCOnst = atob("QGVudkNvbnN0")
//Стeнография, попытка скрыть исходныe строки от хакeров, должна быть строка `xap`
export const pax = paxC.substring(20, 21) + paxC.substring(14, 15) + paxC.substring(7, 8);

if (enableDebug) {
    console.log("xap:" + pax)
}
const paxConf = s7PageInit[envCOnst];
export const useAesCrypt = !!paxConf;
const tabWord = Latin1.parse('\t')

//Данные ключи загружаются с сервера
//let nameParts = Latin1.parse('sdf');
let DynamicTimeBaseCryptKey = Latin1.parse('sdf');
let DynamicTimeBaseCryptKeyStr = Latin1.parse('sdf');
let sharedKey = DynamicTimeBaseCryptKey;
//Переменная, в которой из ContentService придется новая версия крипто ключа
let ContentServiceJsKeyName = DynamicTimeBaseCryptKey;
//let asyncCryptJsKey = 'sdf';
//btoa("reload") = "cmVsb2Fk"
const reload = atob("cmVsb2Fk")
//btoa("oneLastOpportunity") "b25lTGFzdE9wcG9ydHVuaXR5"
const oneLastOpportunity = atob("b25lTGFzdE9wcG9ydHVuaXR5")
const oneLastOpportunityApi = atob("L2FwaS92MS9qc29uL29uZUxhc3RPcHBvcnR1bml0eQ==")
//btoa("/api/v1/json/oneLastOpportunity") "L2FwaS92MS9qc29uL29uZUxhc3RPcHBvcnR1bml0eQ=="
const contentServicePrefix = `${process.env.REACT_APP_PREFIX_CONTENT_SERVICE}${oneLastOpportunityApi}`;
/**
 * Если сервер ответил кодом 402, т.е. не совпали шифры. То вызвается этот метод, для получения свежих ключей с сервера
 * @returns {*}
 */
export const reloadCryptKeys = () => {
    s7AppendLogEvent(oneLastOpportunity, reload)
    const jsKeyName = Base64.stringify(ContentServiceJsKeyName);
    s7ClearCache(jsKeyName);
    if (enableDebug) {
        console.log("WaitVar:" + jsKeyName)
    }
    return new Promise((resolve, reject) => {
        const e = new Date().getTime();
        const scriptId = oneLastOpportunity + e;
        const searchParams = new URLSearchParams('');
        searchParams.append(e, e);
        searchParams.append('v', 2);
        asyncDownload(scriptId, jsKeyName, contentServicePrefix,
            searchParams)
        .then(data => {
            if (data && data.status == 200) {
                if (parseCryptConst(data.data)) {
                    resolve();
                } else {
                    reject();
                }
            } else {
                reject();
            }
        })
        .catch(error => {
            reject(error);
        });
    });
};

/**
 * Вычисляем название переменной, которое будет использоваться при обновление крипт о ключей
 */
/*
function rebuildAsyncConstName1() {
    const msg1 = HmacSHA512(sharedKey, ApiSharedKeyName);
    const msg2 = msg1.toString(Latin1);
    if (enableDebug) {
        console.log("msg11", Base64.stringify(msg1))
    }

    let name = ''
    const parts = nameParts
    const lP = parts.length;
    for (let i = 0; i < lP; i += 2) {
        const i1 = parts.charCodeAt(i);
        const i2 = parts.charCodeAt(i + 1);
        for (let j = i1; j < i2; j++) {
            name += msg2.charAt(j);
        }
    }
    asyncCryptJsKey = Base64.stringify(Latin1.parse(name));
}
*/
/**
 * В первой версии формат. размер сообщения 1 байт далее читаем самом сообщение
 * @param rawData
 * @returns {boolean}
 */

/*
function parseConstVersion1(rawData) {
    const keys = [];
    const l = rawData.length;

    for (let i = 1; i < l;) {
        const keySize = rawData.charCodeAt(i++);
        keys[keys.length] = rawData.substring(i, i + keySize)
        i += keySize
    }

    nameParts = keys[0];
    DynamicTimeBaseCryptKey = Latin1.parse(keys[1]);
    sharedKey = Latin1.parse(keys[2]);
    ApiSharedKeyName = Latin1.parse(keys[3]);
    if (enableDebug) {
        console.log("nameParts", Base64.stringify(Latin1.parse(nameParts)))
        console.log("DynamicTimeBaseCryptKey", Base64.stringify(DynamicTimeBaseCryptKey))
        console.log("sharedKey", Base64.stringify(sharedKey))
    }
    rebuildAsyncConstName1();

    return true;
}
*/

/**
 * В первой версии формат. размер сообщения 1 байт далее читаем самом сообщение
 * @param rawData
 * @returns {boolean}
 */
function parseConstVersion2(rawData) {
    const keys = [];
    const l = rawData.length;

    for (let i = 1; i < l;) {
        const keySize = rawData.charCodeAt(i++);
        keys[keys.length] = rawData.substring(i, i + keySize)
        i += keySize
    }

    ContentServiceJsKeyName = Latin1.parse(keys[0]);
    DynamicTimeBaseCryptKey = Latin1.parse(keys[1]);
    DynamicTimeBaseCryptKeyStr = keys[1];

    if (enableDebug) {
        console.log("ContentServiceJsKeyName2", Base64.stringify(ContentServiceJsKeyName))
        console.log("cryptKey2", Base64.stringify(DynamicTimeBaseCryptKey))
    }

    return true;
}

/**
 * В начале сообщение идет версяи
 * @param data
 * @returns {boolean}
 */
function parseCryptConst(data) {
    const rawData = atobLatin(data);

    const version = rawData.charCodeAt(0);
    switch (version) {
        // case 1:
        //     return parseConstVersion1(rawData);
        case 2:
            return parseConstVersion2(rawData);
    }

    return false;
}

if (useAesCrypt) {
// btoa("s7SubscribeOn") = "czdTdWJzY3JpYmVPbg=="
    //Подписка на событие, загрузки крипто ключей через глобальную шину s7SubscribeOn
    window[atob("czdTdWJzY3JpYmVPbg==")](envCOnst, function (data) {
        parseCryptConst(data);
    }, function () {
    })
}

export const getHash = (value) => {
    return MD5(value).toString();
};

const joinValuesToWordArray = (values, keys) => {
    if (enableDebug) {
        console.log("joinValue456456456456456456")
    }

    const l1 = keys.length;

    let msg = Latin1.parse('');
    for (let i = 0; i < l1; i++) {
        const sub = keys[i];
        const l2 = sub.length;
        msg.concat(tabWord)

        for (let j = 0; j < l2; j++) {
            msg.concat(tabWord)
            msg.concat(Latin1.parse(values[sub[j]]))
        }
    }

    return msg;
}

/**
 * Входящие сообщение зашифровано XOR надо дешифровать
 * @param value
 * @returns {*}
 */
export const unres = (value) => {
    let res = Latin1.parse('');
    let msg = atobLatin(value);
    let l = msg.length;
    let key = DynamicTimeBaseCryptKeyStr;
    let keySize = key.length;
    for (let i = 0; i < l; i++) {
        let i1 = msg.charCodeAt(i);
        let i2 = key.charCodeAt(i % keySize);
        let c = String.fromCharCode(i1 ^ i2);
        res.concat(Latin1.parse(c))
    }
    const utf8Value = res.toString(Utf8);
    if (enableDebug) {
        console.log("UnResUtf8", utf8Value)
    }
    return JSON.parse(utf8Value);
}

export const hmac2 = (values, keys) => {
    const message = joinValuesToWordArray(values, keys);
    if (enableDebug) {
        console.log("messageBefore", Base64.stringify(message))
        console.log("ContentServiceJsKeyName", Base64.stringify(ContentServiceJsKeyName))
    }
    message.concat(ContentServiceJsKeyName)
    if (enableDebug) {
        console.log("messageAfter", Base64.stringify(message))
        console.log("DynamicTimeBaseCryptKey", Base64.stringify(DynamicTimeBaseCryptKey))
    }

    const msg2 = HmacSHA512(message, DynamicTimeBaseCryptKey);
    if (enableDebug) {
        console.log("hmac512", Base64.stringify(msg2))
    }
    return Base64.stringify(msg2);
}

if (enableDebug && false) {
    function main() {
        const parts = atobLatin("BQYJDB4iKCs3PQ==")
        const apiSharedName = Latin1.parse(
            atobLatin("AomAUPebV/l17LkL1yuaYkIlVToJlUBAm6HQLg9KDR4="))
        const cryptKey = Latin1.parse(
            atobLatin("comAUPebV/l17LkL1yuaYkIlVToJlUBAm6HQLg9KDR0="))

        const msg1 = HmacSHA512(apiSharedName, cryptKey);
        const msg2 = msg1.toString(Latin1);

        console.log("msg2", Base64.stringify(msg1))

        let name = ''
        const lP = parts.length;
        for (let i = 0; i < lP; i += 2) {
            const i1 = parts.charCodeAt(i);
            const i2 = parts.charCodeAt(i + 1);
            name += msg2.substring(i1, i2);
            // for (let j = i1; j < i2; j++) {
            //     name += msg2.charAt(j);
            // }
        }
        console.log("nameL", name.length)
        console.log("name64", Base64.stringify(Latin1.parse(name)))
    }

    main();
}